// @flow

import { type OutgoingPayment } from '@tectonics/prs/outgoing-payment';
import { type UserInputValues } from '@tectonics/prs/user-input-values';

export async function tefOutgoingPaymentMapper(userInputValues: UserInputValues): Promise<$Shape<OutgoingPayment>> {
  const selectedBank = userInputValues['selectedTefBank'];
  return {
    payment_type: 'tef',
    payment_type_code: selectedBank,
    instalments: '1',
  };
}
